// Envuelve el render REAL del widget (vía registry) con una barra de controles
// de edición (subir/bajar/editar/materializar/eliminar). En edit-mode el dashboard
// se ve igual pero cada visual gana sus acciones de admin.
import React from 'react';
import { resolveWidget } from '../../../visuals/registry';
import { mapWidgetToBlock } from '../../../visuals/configs/mapDashboardToConfig';

const STATUS_DOT = { ready: '#16a34a', error: '#dc2626', generating: '#d97706', pending: '#94a3b8' };

export default function VisualCard({ widget, theme, data, canUp, canDown, onEdit, onDelete, onMoveUp, onMoveDown, onMaterialize }) {
  const block = mapWidgetToBlock(widget);
  const Widget = resolveWidget(block.type);
  const hasSql = !!(widget.data_sql && widget.data_sql.trim());
  return (
    <div className="vz-cell vz-card--edit" style={{ gridColumn: `span ${block.span || 12}` }}>
      <div className="vz-card-edit-bar">
        <button onClick={onMoveUp} disabled={!canUp} title="Subir">↑</button>
        <button onClick={onMoveDown} disabled={!canDown} title="Bajar">↓</button>
        <span className="vz-card-edit-type">
          {hasSql && (
            <span
              className="vz-status-dot"
              style={{ background: STATUS_DOT[widget.status] || STATUS_DOT.pending }}
              title={`data_sql: ${widget.status || 'pending'}`}
            />
          )}
          {widget.widget_type} · {widget.size}/12
        </span>
        <button onClick={onEdit} title="Editar código">✎</button>
        {hasSql && <button onClick={onMaterialize} title="Materializar (ejecutar data_sql)">↻</button>}
        <button className="vz-card-edit-danger" onClick={onDelete} title="Eliminar">🗑</button>
      </div>
      {Widget
        ? <Widget block={block} data={data} theme={theme} />
        : <div className="vz-card vz-empty">Tipo desconocido: {block.type}</div>}
    </div>
  );
}
